import { useCallback, useEffect } from 'react';

const usePressKey = ({ which, ref, onSelect, preventDefault = true, stopPropagation = false }) => {
  const handlePress = useCallback(
    (e) => {
      if (e.which === which) {
        preventDefault && e.preventDefault();
        stopPropagation && e.stopPropagation();
        onSelect();
      }
    },
    [onSelect, preventDefault, stopPropagation, which]
  );

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.addEventListener('keydown', handlePress);

    return () => {
      node.removeEventListener('keydown', handlePress);
    };
  }, [ref, handlePress]);
};

export default usePressKey;
